/* eslint-disable no-param-reassign */
import { PayloadAction } from '@reduxjs/toolkit';
import { State } from '../menu-list.slice';

export function nextPage(state: State): void {
  state.page += 1;
}

export function prevPage(state: State): void {
  if (state.page === 1) return;
  state.page -= 1;
}

export function setPage(state: State, action: PayloadAction<number>): void {
  if (action.payload < 1) {
    console.error('Page cannot be less than 1');
    return;
  }
  state.page = action.payload;
}
